import { getField, updateField } from 'vuex-map-fields'

export const state = () => ({
  service_code: undefined,
  user_name: undefined,
  user_id: undefined,
  user_contact: undefined,
  bot: undefined,
  channel: undefined,
  evaluation: undefined,
  intent: [],
  conversation_id: undefined,
  email: undefined,
  intents: undefined,
  operator: undefined,
  closedTo: undefined,
  activeChats: undefined,
  searchBarText: undefined,
  cpf: undefined,
  phone: undefined,
  channelFilter: undefined,
  evaluationFilter: undefined,
  intentFilter: undefined,
  activeFilter: undefined,
  group_name: undefined,
  group_toggle: false
})

export const getters = {
  getField
}

export const actions = {
  resetFilter: ({ commit }) => {
    commit('resetFilter')
  }
}

export const mutations = {
  updateField,
  resetFilter (state) {
    state.searchBarText = undefined
    state.service_code = undefined
    state.user_name = undefined
    state.cpf = undefined
    state.phone = undefined
    state.bot = undefined
    state.channelFilter = undefined
    state.evaluationFilter = undefined
    state.intentFilter = undefined
    state.activeFilter = undefined
    state.conversation_id = undefined
    state.intents = []
    state.email = undefined
    state.operator = undefined
    state.closedTo = undefined
    state.group_name = undefined
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
